import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {Link, useParams, useHistory} from "react-router-dom";
import {
    searchEmployeeForm,
    update_form,
    UPDATE_FORM,
    get_all_employee_form,
    clear_status_form,
    UPDATE_FORM_FIELD,
    SEND_FORM_EMPLOYEE,
    update_form_field,
    send_form_employee
} from "../../../redux/forms";
import LoadingSpinner from '../../../components/loading-spinner';
import {URLAPI} from "../../../config/index";
import Button from "../../../components/button";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Modal from "../../../components/modal";
import TextArea from "../../../components/text-area";
import Input from "../../../components/input";
import SelectInput from "../../../components/select";

const ItemDatas = (props) => {
    const {id} = useParams();

    const dispatch = useDispatch();
    let history = useHistory();

    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _update_form = useSelector((state) => state.form_module._update_form);
    const _send_form_employee = useSelector((state) => state.form_module._send_form_employee);
    const _update_form_field = useSelector((state) => state.form_module._update_form_field);

    const [isLoading, setIsLoading] = useState(false);
    const [modal_aprobar, setModalAprobar] = useState(false);
    const [modal_rechazar, setModalRechazar] = useState(false);
    const [modal, setModal] = useState(false);
    const [comentario, setComentario] = useState('');
    const [data, setData] = useState({});
    const [permisos, setPermisos] = useState([]);
    const [item, setItem] = useState({
        id: null,
        nombre: "",
        valor: "",
        tipo: "",
        opciones: []
    });


    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    async function getEmployeeForm() {
        setIsLoading(true);
        const params = '?id_empleado=' + id;
        try {
            const response = await searchEmployeeForm(token, params);
            if (response && response.data && response.data.datos) {
                setData(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getEmployeeForm();
        // eslint-disable-next-line
    }, [token, id]);

    useEffect(() => {
        if (_update_form.status === 200) {
            dispatch(clear_status_form(UPDATE_FORM));
            dispatch(get_all_employee_form(token));
            setIsLoading(false);
            setModalAprobar(false);
            setModalRechazar(false);
            history.push("/empleados-formularios");
        } else {
            if (_update_form.status !== 0) {
                toast.error(_update_form.message);
                setIsLoading(false);
            }
        }
    }, [_update_form, dispatch, history, token]);
    

    function update_state(value) {
        setIsLoading(true);
        let va = {'tipo': value}
        if (value === 'rechazar'){
            if (comentario === "") {
                toast.error("Debe ingresar un comentario");
                setIsLoading(false);
                return;
            }
            va = {'tipo': value, 'comentario': comentario}
        }

        dispatch(update_form(token, data.id_formulario, va));
    }

    const handleChange = (e) => {
        setItem({
            ...item,
            valor: e.target.value,
        });
    }

    const handleFileChange = (e) => {
        setItem({
            ...item,
            valor: e.target.files[0],
        });
    };

    useEffect(() => {
        if (_update_form_field.status === 200) {
            toast.success("Actualizado correctamente");
            dispatch(clear_status_form(UPDATE_FORM_FIELD));
            getEmployeeForm();
            setIsLoading(false);
            setModal(false);
        } else {
            if (_update_form_field.status !== 0) {
                dispatch(clear_status_form(UPDATE_FORM_FIELD));
                toast.error(_update_form_field.message);
                setIsLoading(false);
            }
        }
        // eslint-disable-next-line
    }, [_update_form_field, dispatch, token]);

    const handleField = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const form = new FormData();
        form.append("tipo", item.tipo);
        form.append("valor", item.valor);
        if (item.tipo === "image"){
            form.append("imagen", item.valor);
        }
        if (item.tipo === "file"){
            form.append("archivo", item.valor);
        }
        dispatch(update_form_field(token, item.id, form));
    }

    useEffect(() => {
        if (_send_form_employee.status === 200) {
            dispatch(clear_status_form(SEND_FORM_EMPLOYEE));
            toast.success(_send_form_employee.data.mensaje);
            setIsLoading(false);
        } else {
            if (_send_form_employee.status !== 0) {
                toast.error(_send_form_employee.message);
                setIsLoading(false);
            }
        }
    }, [_send_form_employee, dispatch]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Formulario empleados"
                            items={[{label: "Verificación de datos", link: "/empleados-formularios"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <p>{data.valido}</p>
                                {data &&
                                    data.valido === true ?
                                    <>
                                        <div className="row">
                                            <div className="col-12 text-right">
                                                <h5>{data.estado}</h5>
                                            </div>
                                            <div className="col-md-8 col-12">
                                                <h5>Tipo de formulario: {data.tipo}</h5>
                                            </div>
                                            <div className="col-md-4 col-12 text-right">
                                                {/* eslint-disable-next-line*/}
                                                <a href={URLAPI + data.firma} target="_blank" style={{textDecoration: 'underline'}}>Descargar archivo firmado</a>
                                            </div>
                                            {data.datos.map(x => 
                                                <div className="col-12 mb-2">
                                                    <h5>{x.titulo}</h5>
                                                    {x.grupos.map(g => 
                                                        g.campos.map(c => 
                                                            <div className="row pt-1 pb-1 mb-1" style={{border: '2px solid #BDBDBD', margin: '0 5px'}}>
                                                                {c.map(f =>
                                                                        <div className="col-md-6 col-12 mt-1">
                                                                            {/*<p>editable: {f.editable === 'true'}</p>*/}
                                                                            <label>{f.nombre}</label>
                                                                            {(f.image) ?
                                                                                <div className="text-center">
                                                                                    {/* eslint-disable-next-line*/}
                                                                                    <a href={URLAPI + f.image} target="_blank" className="btn btn-warning">Ver imagen</a>
                                                                                    {(permisos && permisos.filter(x => (x.codigo === 'edit_information').length > 0) && f.editable === true && data.estado === 'Completo') &&
                                                                                        <button style={{marginLeft: 5}} className="btn btn-primary" onClick={() => {
                                                                                            setItem(({
                                                                                                id: f.id_detalle,
                                                                                                nombre: f.nombre,
                                                                                                valor: f.valor,
                                                                                                tipo: f.tipo,
                                                                                                opciones: f.opciones,
                                                                                            }));
                                                                                            setModal(true);
                                                                                        }}>Editar</button>
                                                                                    }
                                                                                </div>
                                                                            : (f.file) ?
                                                                                <div className="text-center">
                                                                                    {/* eslint-disable-next-line*/}
                                                                                    <a href={URLAPI + f.file} target="_blank" className="btn btn-info">Ver archivo</a>
                                                                                    {(permisos && permisos.filter(x => (x.codigo === 'edit_information').length > 0) && f.editable === true && data.estado === 'Completo') &&
                                                                                        <button style={{marginLeft: 5}} className="btn btn-primary" onClick={() => {
                                                                                            setItem(({
                                                                                                id: f.id_detalle,
                                                                                                nombre: f.nombre,
                                                                                                valor: f.valor,
                                                                                                tipo: f.tipo,
                                                                                                opciones: f.opciones,
                                                                                            }));
                                                                                            setModal(true);
                                                                                        }}>Editar</button>
                                                                                    }
                                                                                </div>
                                                                            :
                                                                                <div className="d-flex">
                                                                                    <input class="form-control" value={f.valor} readOnly/>
                                                                                    {(permisos && permisos.filter(x => (x.codigo === 'edit_information').length > 0) && f.editable === true && data.estado === 'Completo') &&
                                                                                        <button style={{marginLeft: 5}} className="btn btn-primary" onClick={() => {
                                                                                            setItem(({
                                                                                                id: f.id_detalle,
                                                                                                nombre: f.nombre,
                                                                                                valor: f.valor,
                                                                                                tipo: f.tipo,
                                                                                                opciones: f.opciones,
                                                                                            }));
                                                                                            setModal(true);
                                                                                        }}>Editar</button>
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                )}
                                                            </div>   
                                                        )
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                        <div className="card-footer d-flex justify-content-end">
                                            <Link to="/empleados-formularios" className="btn btn-danger m-1">
                                                Cancelar
                                            </Link>
                                            { permisos &&
                                                permisos.filter(x => (x.codigo === 'change_forms').length > 0) &&
                                                data.estado === 'Completo' &&
                                                    <>
                                                        <Button
                                                            type="button"
                                                            text="Rechazar"
                                                            onChange={() => {
                                                                setModalRechazar(true);
                                                                setComentario('');
                                                            }}
                                                            disabled={isLoading}
                                                            className="m-md-1 btn btn-secondary"
                                                        />
                                                        <Button
                                                            type="button"
                                                            text="Aprobar"
                                                            theme="success"
                                                            onChange={() => {setModalAprobar(true);}}
                                                            disabled={isLoading}
                                                        />
                                                    </>
                                                
                                            }
                                            { permisos &&
                                                permisos.filter(x => (x.codigo === 'change_forms').length > 0) &&
                                                data.estado === 'Aprobado' &&
                                                <Button
                                                    type="button"
                                                    text="Reenviar"
                                                    onChange={() => {
                                                        setModalRechazar(true);
                                                        setComentario('');
                                                    }}
                                                    disabled={isLoading}
                                                    className="m-md-1 btn btn-secondary"
                                                />
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <p>{data.estado}</p>
                                        { permisos && permisos.filter(x => (x.codigo === 'change_forms').length > 0) &&
                                            <div>
                                                <Button
                                                    text="Enviar formulario"
                                                    theme="success"
                                                    type="button"
                                                    classes="btn-lg round"
                                                    onClick={() => {
                                                        setIsLoading(true);
                                                        dispatch(send_form_employee(token, id, {}));
                                                    }}
                                                />
                                            </div>
                                        }
                                        <div className="text-center">
                                            <h5>{data.mensaje}</h5>
                                        </div>
                                        <div className="card-footer d-flex justify-content-end">
                                            <Link to="/empleados-formularios" className="btn btn-danger m-1">
                                                Cancelar
                                            </Link>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal_aprobar}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="text-center">
                            <img
                                className="img-fluid"
                                src={
                                    window.location.origin +
                                    "/base/app-assets/images/icon/help.png"
                                }
                                alt="branding logo"
                            />
                            <h5 className="mt-2">¿Desea marcar el formulario como aprobado?. Esta acción no se puede deshacer</h5>
                        </div>
                    </div>
                    <div className="text-center">
                        <button type="button" className="btn btn-outline-dark" onClick={() => {
                            setModalAprobar(false)
                        }}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-dark m-1" onClick={() => {
                            update_state('aprobar')
                        }} disabled={isLoading}>
                            Confirmar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal className="modal-main div-modal" show={modal_rechazar}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="text-center">
                            <img
                                className="img-fluid"
                                src={
                                    window.location.origin +
                                    "/base/app-assets/images/icon/help.png"
                                }
                                alt="branding logo"
                            />
                            {data.estado === 'Completo' ?
                                <h5 className="mt-2">Rechazar formulario. Por favor ingrese un comentario por el cual se rechaza el formulario</h5>
                                :
                                <h5 className="mt-2">Reenviar formulario. Por favor ingrese un comentario por el cual se reenvia el formulario</h5>
                            }
                        </div>
                        <dv>
                            <TextArea
                                id="comentario"
                                name="comentario"
                                label="Comentario"
                                placeholder=""
                                value={comentario}
                                onChange={(e) => {setComentario(e.target.value)}}
                                rows={4}
                            />
                        </dv>
                    </div>
                    <div className="text-center">
                        <button type="button" className="btn btn-outline-dark" onClick={() => {
                            setModalRechazar(false)
                        }}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-dark m-1" onClick={() => {
                            update_state('rechazar')
                        }} disabled={isLoading}>
                            Guardar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleField}>
                    <div className="card-body">
                        <h5 className="mb-2">Actualizar información</h5>
                        <div className="form-group">
                            {(item.tipo === 'image' || item.tipo === 'file') ?
                                <Input
                                    type="file"
                                    label={item.nombre}
                                    onChange={handleFileChange}
                                    name={item.nombre}
                                    accept={item.tipo === 'image' ? "image/*" : "application/pdf"}
                                />
                            : item.tipo === 'select' ?
                                <SelectInput
                                    name={item.nombre}
                                    label={item.nombre}
                                    options={item.opciones.map((item) => ({
                                        name: item.nombre,
                                        id: item.id,
                                    }))}
                                    onChange={handleChange}
                                    select={item.valor}
                                />
                            : item.tipo === 'textarea' ?
                                <TextArea
                                    name={item.nombre}
                                    label={item.nombre}
                                    placeholder=""
                                    onChange={handleChange}
                                    rows={4}
                                    value={item.valor}
                                />
                            :
                                <Input
                                    type={item.tipo}
                                    label={item.nombre}
                                    onChange={handleChange}
                                    name={item.nombre}
                                    value={item.valor}
                                />
                            }
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button className={`btn btn-success button_div mb-1`} disabled={isLoading}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
}

export default ItemDatas;